import { render } from "./SellerGrid.vue?vue&type=template&id=388489ba"
import script from "./SellerGrid.vue?vue&type=script&lang=js"
export * from "./SellerGrid.vue?vue&type=script&lang=js"

import "./SellerGrid.vue?vue&type=style&index=0&id=388489ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__